import { Button, Flex, Form, Radio, Text } from "../../components";
import { PaymentOption } from "../../types/app";
import { FormInstance } from "antd";
import { twMerge } from "tailwind-merge";

const PaymentSelect = ({
  infoForm,
  availablePayments,
  onConfirm,
}: {
  infoForm: FormInstance;
  availablePayments: PaymentOption[];
  onConfirm: () => Promise<void>;
}) => {
  const paymentMethod =
    Form.useWatch("paymentMethod", infoForm) ||
    availablePayments[0]?.method ||
    "cod";

  return (
    <Flex vertical align="flex-start" gap="1.5rem" className="w-100">
      <Flex vertical gap="1rem" className="w-100">
        {availablePayments.map((item) => {
          const selected = paymentMethod === item.method;
          return (
            <Flex
              key={item.method}
              vertical
              align="flex-start"
              justify="center"
              className={twMerge(
                "w-full min-h-[6.4rem] cursor-pointer rounded-card border-[length:var(--border-width)] border-solid px-[1.8rem] py-[1.6rem]",
                selected
                  ? "border-action-base bg-[rgba(210,43,43,0.08)]"
                  : "border-divider bg-surface-header",
              )}
              onClick={() =>
                infoForm.setFieldValue("paymentMethod", item.method)
              }
            >
              <Radio
                checked={selected}
                label={item.displayName || item.method}
              />
              {selected && item.instructions && (
                <Flex vertical align="flex-start" className="pl-[3.2rem]">
                  <Text
                    type="secondary"
                    className="!mt-[5px]"
                    children={item.instructions}
                  />
                </Flex>
              )}
            </Flex>
          );
        })}
      </Flex>

      <Button
        color="base"
        className="w-100 !mt-[20px]"
        title="Confirm order"
        onClick={onConfirm}
      />
    </Flex>
  );
};

export default PaymentSelect;
